export interface AppRouteMeta {
  id: string;
  path: string;
  parentId?: string;
  label: string;
  breadcrumbVisible: boolean;
}

export const appRoutes: AppRouteMeta[] = [
  { id: 'home', path: '/home', label: 'Home', breadcrumbVisible: true },

  // Events
  { id: 'events', path: '/events', parentId: 'home', label: 'Events', breadcrumbVisible: true },
  { id: 'event-new', path: '/events/new', parentId: 'events', label: 'New', breadcrumbVisible: true },
  { id: 'event-details', path: '/events/:id', parentId: 'events', label: 'Event', breadcrumbVisible: true },
  { id: 'event-edit', path: '/events/:id/edit', parentId: 'event-details', label: 'Edit', breadcrumbVisible: true },
  { id: 'event-guests', path: '/events/:id/guests', parentId: 'event-details', label: 'Guests', breadcrumbVisible: true },
  { id: 'event-tasks', path: '/events/:id/tasks', parentId: 'event-details', label: 'Tasks', breadcrumbVisible: true },
  { id: 'event-seating', path: '/events/:id/seating', parentId: 'event-details', label: 'Seating', breadcrumbVisible: true },
  { id: 'event-add-member', path: '/events/:id/add-member', parentId: 'event-details', label: 'Add Member', breadcrumbVisible: true },
  { id: 'event-services', path: '/events/:id/services', parentId: 'event-details', label: 'Services', breadcrumbVisible: true },
  { id: 'event-activities', path: '/events/:eventId/activities', parentId: 'event-details', label: 'Activities', breadcrumbVisible: true },
  { id: 'event-activity-new', path: '/events/:eventId/activities/new', parentId: 'event-activities', label: 'New', breadcrumbVisible: true },
  { id: 'event-activity-edit', path: '/events/:eventId/activities/:id/edit', parentId: 'event-activities', label: 'Edit', breadcrumbVisible: true },
  { id: 'activity-details', path: '/activities/:id', parentId: 'events', label: 'Activity', breadcrumbVisible: true },
  { id: 'sub-activity-new', path: '/activities/:id/sub-activities/new', parentId: 'activity-details', label: 'New Sub Activity', breadcrumbVisible: true },

  // Venues & Vendors
  { id: 'venues', path: '/venues', parentId: 'home', label: 'Venues', breadcrumbVisible: true },
  { id: 'celebration-venues', path: '/celebrations/:celebrationId/venues', parentId: 'celebration-details', label: 'Venues', breadcrumbVisible: true },
  { id: 'celebration-venue-details', path: '/celebrations/:celebrationId/venues/:id', parentId: 'celebration-venues', label: 'Venue', breadcrumbVisible: true },
  { id: 'venue-details', path: '/venues/:id', parentId: 'venues', label: 'Venue', breadcrumbVisible: true },
  // Celebrations
  { id: 'celebrations', path: '/celebrations', parentId: 'home', label: 'Celebrations', breadcrumbVisible: true },
  { id: 'celebration-new', path: '/celebrations/new', parentId: 'celebrations', label: 'New', breadcrumbVisible: true },
  { id: 'celebration-details', path: '/celebrations/:id', parentId: 'celebrations', label: 'Celebration', breadcrumbVisible: true },
  { id: 'celebration-edit', path: '/celebrations/:id/edit', parentId: 'celebration-details', label: 'Edit', breadcrumbVisible: true },
  { id: 'celebration-setup', path: '/celebrations/:id/setup', parentId: 'celebration-details', label: 'Setup', breadcrumbVisible: true },
  { id: 'celebration-team', path: '/celebrations/:celebrationId/team', parentId: 'celebration-details', label: 'Team Members', breadcrumbVisible: true },
  { id: 'celebration-events', path: '/celebrations/:celebrationId/events', parentId: 'celebration-details', label: 'Events', breadcrumbVisible: true },
  { id: 'celebration-event-new', path: '/celebrations/:celebrationId/events/new', parentId: 'celebration-events', label: 'New', breadcrumbVisible: true },
  { id: 'celebration-guests', path: '/celebrations/:celebrationId/guests', parentId: 'celebration-details', label: 'Guests', breadcrumbVisible: true },
  { id: 'celebration-guest-quotas', path: '/celebrations/:id/guest-quotas', parentId: 'celebration-details', label: 'Celebration Quotas & Allocations', breadcrumbVisible: true },
  { id: 'celebration-email-templates', path: '/celebrations/:id/email-templates', parentId: 'celebration-details', label: 'Email Templates', breadcrumbVisible: true },
  { id: 'celebration-tasks', path: '/celebrations/:id/tasks', parentId: 'celebration-details', label: 'Tasks', breadcrumbVisible: true },
  { id: 'celebration-goals', path: '/celebrations/:id/goals', parentId: 'celebration-details', label: 'Goals', breadcrumbVisible: true },
  { id: 'celebration-settings', path: '/celebrations/:id/settings', parentId: 'celebration-details', label: 'Settings', breadcrumbVisible: true },
  { id: 'celebration-guest-landing', path: '/celebrations/:id/guest-landing', parentId: 'celebration-details', label: 'Guest Landing', breadcrumbVisible: true },
  { id: 'celebration-registries', path: '/celebrations/:id/registries', parentId: 'celebration-details', label: 'Registries', breadcrumbVisible: true },
  { id: 'celebration-invitations', path: '/celebrations/:celebrationId/invitations', parentId: 'celebration-details', label: 'Invitations', breadcrumbVisible: true },
  { id: 'celebration-blockers', path: '/celebrations/:celebrationId/blockers', parentId: 'celebration-details', label: 'Blockers', breadcrumbVisible: true },
  { id: 'celebration-budget', path: '/celebrations/:celebrationId/budget', parentId: 'celebration-details', label: 'Budget', breadcrumbVisible: true },
  { id: 'dress-code', path: '/celebrations/:celebrationId/events/:eventId/dress-code', parentId: 'celebration-details', label: 'Dress Code', breadcrumbVisible: true },

  // Celebration services
  { id: 'celebration-services-edit', path: '/celebrations/:celebrationId/services/edit', parentId: 'celebration-details', label: 'Service Preferences', breadcrumbVisible: true },
  { id: 'celebration-services', path: '/celebrations/:celebrationId/services', parentId: 'celebration-details', label: 'Services', breadcrumbVisible: true },
  { id: 'celebration-services-select', path: '/celebrations/:celebrationId/services/select', parentId: 'celebration-services', label: 'Select Services', breadcrumbVisible: true },
  { id: 'service-request-post', path: '/celebrations/:celebrationId/services/:serviceId/requests/:requestId/post', parentId: 'celebration-services', label: 'Post to Vendors', breadcrumbVisible: true },

  // Other app pages
  { id: 'services', path: '/services', parentId: 'home', label: 'Services', breadcrumbVisible: true },
  { id: 'conversation', path: '/conversation', parentId: 'home', label: 'Conversation', breadcrumbVisible: true },
  { id: 'celebration-chat', path: '/celebration-chat', parentId: 'home', label: 'Celebration Chat', breadcrumbVisible: true },
  { id: 'chat', path: '/chat', parentId: 'home', label: 'Chat', breadcrumbVisible: true },
  { id: 'contacts', path: '/contacts', parentId: 'home', label: 'Contacts', breadcrumbVisible: true },
  { id: 'profile', path: '/profile', parentId: 'home', label: 'Profile', breadcrumbVisible: true },
  { id: 'how-to', path: '/how-to', parentId: 'home', label: 'How To', breadcrumbVisible: true },
  { id: 'feedback', path: '/feedback', parentId: 'home', label: 'Feedback', breadcrumbVisible: true },
];

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

const routeById = new Map(appRoutes.map((route) => [route.id, route]));

const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const patternToRegExp = (path: string) => {
  const regexPattern = `^${path
    .split('/')
    .map((segment) => {
      if (!segment) {
        return '';
      }
      return segment.startsWith(':') ? '([^/]+)' : escapeRegex(segment);
    })
    .join('/')}$`;

  return new RegExp(regexPattern);
};

const getMatchingRoute = (pathname: string) => {
  const normalized = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
  return appRoutes.find((route) => patternToRegExp(route.path).test(normalized));
};

const fillParams = (path: string, pathname: string) => {
  const pathSegments = path.split('/');
  const currentSegments = pathname.split('/');

  return pathSegments
    .map((segment, index) => (segment.startsWith(':') ? currentSegments[index] ?? segment : segment))
    .join('/');
};

export const buildBreadcrumbsForPath = (pathname: string, overrides: Partial<Record<string, string>> = {}): BreadcrumbItem[] => {
  const matched = getMatchingRoute(pathname);
  if (!matched) {
    return [];
  }

  const chain: AppRouteMeta[] = [];
  let current: AppRouteMeta | undefined = matched;

  while (current) {
    chain.unshift(current);
    current = current.parentId ? routeById.get(current.parentId) : undefined;
  }

  const visibleChain = chain.filter((route) => route.breadcrumbVisible);

  if (!visibleChain.length) {
    return [];
  }

  return visibleChain.map((route, index) => {
    const routePath = fillParams(route.path, pathname);
    const isLast = index === visibleChain.length - 1;
    return {
      label: overrides[route.id] ?? route.label,
      to: isLast ? undefined : routePath,
    };
  });
};
